import { Directive } from '@angular/core';

@Directive({
  selector: '[qpointPolygonPopUpScalingFactorRequiredTemplate]',
  standalone: true
})
export class QPointPolygonPopUpScalingFactorRequiredTemplateDirective {}
